import Order from './order';
import Retrieve from './retrieve';
import Settings from './settings';
import ManuallyBooking from '../components/forms/ManuallyBooking';
import Administration from './administration';
import Reservation from './reservation';
import Registration from './registration';
import DeferredPayment from './deferredPayment';
import InvoluntaryChangesAtCom from './involuntaryChangesAtCom';
import { CommonRoutes } from './common-routes';
import AmendFailures from './amend-failures';
import WelcomePage from './WelcomePage';
import NdcxImportPage from './ndcx-import';
import { Navigate, Routes, Route } from 'react-router-dom';
import InvoluntaryChanges from './involuntary-changes/involuntary-changes';
import { keycloak } from '../keycloak';
import { withRouter } from './withRouter';

const AppRoutes = () => {
  return (
    <Routes>
      {/* Welcome  */}
      {<Route path="welcome" element={<WelcomePage />} />}

      {/* Order sub-route */}
      <Route path="order/*" element={<Order />} />

      {/* Retrieve sub-route */}
      <Route path="retrieve/*" element={<Retrieve />} />

      {/* settings purposes */}
      <Route path="settings/*" element={<Settings />} />

      {/* user administration */}
      <Route path="administration/*" element={<Administration />} />

      {/* registration */}
      <Route path="registration/*" element={<Registration />} />

      {/* involuntary-changes */}
      <Route
        path="involuntary-changes"
        element={
          keycloak.hasRealmRole('Role_IT_Administrator') ? (
            <InvoluntaryChanges />
          ) : (
            <Navigate to={'/tff/common/error-403'} />
          )
        }
      />

      <Route path="amend-failures/*" element={<AmendFailures />} />

      <Route path="manually-booking" element={<ManuallyBooking />} />

      <Route path="common/*" element={<CommonRoutes />} />

      <Route path="reservation" element={<Reservation />} />

      <Route path="deferred-payment/*" element={<DeferredPayment />} />

      <Route path="involuntary-changes-atCom/*" element={<InvoluntaryChangesAtCom />} />

      <Route path="ndcx-import" element={<NdcxImportPage />} />
    </Routes>
  );
};

export default withRouter(AppRoutes);
